const UploadIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 36.066 50">
            <g id="Group_7052">
                <path
                    id="Path_3226"
                    d="M0,15.648c0,4.034,3.767,7.3,8.415,7.3H30.656c2.989,0,5.41-2.1,5.41-4.7s-2.421-4.693-5.41-4.693h-1.8v-4.7C28.852,3.97,24.277,0,18.634,0c-5.452,0-9.9,3.68-10.2,8.346C3.785,8.346,0,11.615,0,15.648"
                    fill="#d6d6d6"
                />
                <path
                    id="Path_3227"
                    d="M17.213,37.992a.82.82,0,1,0,1.639,0Zm1.4-15.334a.822.822,0,0,0-1.161,0l-5.215,5.216A.82.82,0,0,0,13.4,29.034L18.033,24.4l4.636,4.638a.821.821,0,0,0,1.161-1.161ZM.82,17.5a.82.82,0,0,0,0,1.639Zm34.426,1.639a.82.82,0,0,0,0-1.639Zm-16.393,4.1H17.213V37.992h1.639ZM.82,19.139H35.246V17.5H.82Z"
                    transform="translate(0 11.189)"
                    fill="#7b848e"
                />
            </g>
        </svg>
    );
};

export default UploadIcon;
